import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { IndentDetailPage } from "@/features/stores/components/indent-pages";

export const Route = createFileRoute("/_app/stores/indents/$id")({
  beforeLoad: () => {
    const can = useAuth.getState().can;
    if (!can("stores.view") && !can("stores.indent.raise"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <IndentDetailPage key={id} id={Number(id)} />;
}
